import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["pending", "paid", "shipped", "delivered", "cancelled", "refunded"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("");

  const load = async () => {
    const { data } = await api.get(`/admin/orders${filter ? `?status=${filter}` : ""}`);
    setOrders(data);
  };
  useEffect(() => { load(); }, [filter]);

  const setStatus = async (id, status) => {
    try {
      await api.put(`/admin/orders/${id}/status`, { status });
      toast.success("Status updated.");
      load();
    } catch { toast.error("Update failed."); }
  };

  return (
    <div data-testid="admin-orders">
      <div className="flex items-baseline justify-between mb-8">
        <div>
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Fulfilment</p>
          <h1 className="font-serif text-4xl">Orders</h1>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="border border-black/10 px-3 py-2 text-sm" data-testid="admin-orders-filter">
          <option value="">All statuses</option>
          {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div className="bg-white border border-black/5">
        <table className="w-full text-sm">
          <thead className="text-left text-[11px] uppercase tracking-nav text-[#7A7A7A] border-b border-black/5">
            <tr>
              <th className="px-4 py-3">Order</th>
              <th className="px-4 py-3">Customer</th>
              <th className="px-4 py-3">Items</th>
              <th className="px-4 py-3">Total</th>
              <th className="px-4 py-3">Payment</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.order_id} className="border-b border-black/5" data-testid={`admin-order-${o.order_id}`}>
                <td className="px-4 py-3 font-mono-alt text-xs">{o.order_id}<br /><span className="text-[10px] text-[#7A7A7A]">{o.created_at?.slice(0, 10)}</span></td>
                <td className="px-4 py-3">{o.shipping_address?.full_name}<br /><span className="text-[11px] text-[#7A7A7A]">{o.email}</span></td>
                <td className="px-4 py-3">{o.items?.length}</td>
                <td className="px-4 py-3 font-mono-alt">₹{Math.round(o.total_inr).toLocaleString("en-IN")}</td>
                <td className="px-4 py-3">
                  <span className={`text-[11px] uppercase tracking-nav ${o.payment_status === "paid" ? "text-[#388E3C]" : "text-[#7A7A7A]"}`}>{o.payment_status}</span>
                </td>
                <td className="px-4 py-3">
                  <select value={o.status} onChange={(e) => setStatus(o.order_id, e.target.value)} className="border border-black/10 px-2 py-1 text-sm" data-testid={`admin-order-status-${o.order_id}`}>
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
